import { createApp } from 'vue'

import { createPinia } from 'pinia'  //引入仓库
import router from '@/router/index.js'  //引入定义的路由文件
import Pagination from '@/components/Pagination'  //引入全局组件
import mitt from 'mitt'  //引入全局事件总线
import "@/mock/mockServe"  //引入mockServe文件让其执行一次
import App from './App.vue'  //引入App组件


const app = createApp(App)

app.use(createPinia())  //使用仓库
app.use(router)  //使用app的方法（使用路由）
app.component(Pagination.name, Pagination)  //注册全局组件
app.config.globalProperties.mittBus = new mitt()  //注册全局事件总线
app.mount('#app')
